<template>
  <div>
    <meter
      class="timer__meter"
      :min="startTime"
      :max="startTime + durationN"
      :value="currentTime"
    />
  </div>
</template>
<script>
export default {
  props: {
    startTime: {
      type: Number,
      default: 0,
      required: true,
    },
    duration: {
      type: Number,
      default: 5000,
      required: true,
    },
    paused: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      currentTime: 0,
      updateTimeoutId: null,
      updateTimeoutInterval: 50,
    }
  },

  computed: {
    endTime: function () {
      return this.startTime + this.durationN
    },
    durationN: function () {
      return Number(this.duration)
    },
  },

  watch: {
    startTime: function () {
      this.updateTimer()
    },
    paused: function () {
      this.updateTimer()
    },
    duration: function () {
      // duration の 1% を更新間隔の目安に、50ms〜1000ms にクランプする。
      // 旧実装は Math.min(durationN / 100) と引数1個だったため何もクランプされず、
      // 外側の Math.max が常に 1000 以上を返してしまい、短い duration でガクガクになり、
      // 長い duration から短い duration へ戻すとプログレスバーが進まなくなっていた。
      this.updateTimeoutInterval = Math.max(50, Math.min(this.durationN / 100, 1000))
      this.updateTimer()
    },
  },
  created: function () {
    if (!this.paused) {
      this.updateTimer()
    }
  },

  destroyed() {
    this.stop()
  },

  methods: {
    updateTimer() {
      if (this.paused) {
        return
      }
      this.currentTime = Date.now()
      if (this.currentTime >= this.endTime) {
        this.stop()
        this.$emit('timeout')
        return
      }
      clearTimeout(this.updateTimeoutId)
      this.updateTimeoutId = setTimeout(this.updateTimer, this.updateTimeoutInterval)
    },
    stop() {
      clearTimeout(this.updateTimeoutId)
      this.updateTimeoutId = null
      this.currentTime = 0
    },
  },
}
</script>
<style lang="scss" scoped>
.timer__meter {
  margin: 0;
  padding: 0;
  border: none;
}
</style>